var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as Actions from '../actions/organization.actions';
var initialState = {
    id: '',
    name: '',
    masterLanguage: '',
    featureFlags: [],
    infClassifications: {},
    pageTags: {},
    organizationLanguages: [],
    whitelistedDomains: [],
};
var organization = function (state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.SET_ORGANIZATION_DATA: {
            return __assign(__assign({}, initialState), action.payload);
        }
        case Actions.UPDATE_ORG_FEATURE: {
            return __assign(__assign({}, state), { featureFlags: state.featureFlags.map(function (feature) {
                    return feature.featureId !== action.payload.featureId ? feature : action.payload;
                }) });
        }
        case Actions.UPDATE_ORGANIZATION_LANGUAGES: {
            return __assign(__assign({}, state), { organizationLanguages: action.payload.organizationLanguages });
        }
        case Actions.ADD_ORG_CLASSIFICATION: {
            return __assign(__assign({}, state), { infClassifications: __assign(__assign({}, state.infClassifications), (_a = {}, _a[action.payload.name] = action.payload.description, _a)) });
        }
        case Actions.REMOVE_ORG_CLASSIFICATION: {
            var newState = __assign({}, state);
            delete state.infClassifications[action.payload];
            return newState;
        }
        case Actions.ADD_TAG_TO_PAGE: {
            return __assign(__assign({}, state), { pageTags: __assign(__assign({}, state.pageTags), (_b = {}, _b[action.payload.page] = state.pageTags[action.payload.page]
                    ? __spreadArray(__spreadArray([], state.pageTags[action.payload.page]), [action.payload.tag]) : [action.payload.tag], _b)) });
        }
        case Actions.REMOVE_TAG_TO_PAGE: {
            return __assign(__assign({}, state), { pageTags: __assign(__assign({}, state.pageTags), (_c = {}, _c[action.payload.page] = state.pageTags[action.payload.page].filter(function (t) { return t.tagGroup !== action.payload.tag.tagGroup && t.tagValue !== action.payload.tag.tagValue; }), _c)) });
        }
        case Actions.DEFINE_WHITELISTED_DOMAINS: {
            return __assign(__assign({}, state), { whitelistedDomains: action.payload.domains });
        }
        default: {
            return state;
        }
    }
};
export default organization;



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/reducers/organization.reducer.ts
// module id = 1479
// module chunks = 81